import styled from 'styled-components';
import { v2Colors, v2FontFamily, v2Breakpoints } from '../../../../formInputsV2/styles/tokens';

// v2 look for the result-page quote/risk selection modals.
//
// Pure CSS on Bootstrap's own modal classes (.modal-content/.modal-header/
// .modal-body/.modal-footer/.btn-close/.btn-danger), so the JSX and every
// modal's logic stay exactly as they were — a modal only swaps its wrapper
// from RespCivileModal to this. The backoffice modals still use
// RespCivileModal on purpose.
//
// Header and footer stay pinned while only the body scrolls, so "Chiudi" and
// the X are always reachable however many quotes are listed.
export const ResultModal = styled.div`
  font-family: ${v2FontFamily};

  .modal-dialog {
    @media screen and (min-width: 800px) {
      max-width: 1000px;
    }

    @media screen and (max-width: 799px) {
      max-width: calc(100% - 24px);
      margin: 12px auto;
    }
  }

  .modal-content {
    border: 0;
    border-radius: 20px;
    background: #fff;
    box-shadow: 0 24px 64px rgba(16, 24, 40, 0.24);
    overflow: hidden;
    max-height: calc(100vh - 48px);
    max-height: calc(100dvh - 48px);
  }

  .modal-header {
    padding: 18px 24px;
    gap: 12px;
    border-bottom: 1px solid ${v2Colors.disabledSurface};
    background: #fff;
  }

  .modal-title {
    min-width: 0;
    margin: 0;
    overflow-wrap: anywhere;
    color: ${v2Colors.text};
    font-family: ${v2FontFamily};
    font-size: 18px;
    font-weight: 700;
    line-height: 1.3;
    letter-spacing: -0.01em;
  }

  /* Some modals nest an <h5> inside the title */
  .modal-title h5 {
    margin: 0;
    color: inherit;
    font: inherit;
    letter-spacing: inherit;
  }

  .modal-header .btn-close {
    box-sizing: border-box;
    flex-shrink: 0;
    width: 32px;
    height: 32px;
    margin: 0 0 0 auto;
    padding: 0;
    border-radius: 50%;
    background-size: 12px auto;
    opacity: 0.7;
    transition: background-color 150ms ease, opacity 150ms ease;

    &:hover {
      background-color: ${v2Colors.disabledSurface};
      opacity: 1;
    }

    &:focus,
    &:focus-visible {
      outline: 0;
      opacity: 1;
      box-shadow: 0 0 0 3px ${v2Colors.primarySoftHover};
    }
  }

  .modal-body {
    min-height: 0;
    padding: 20px 24px;
    background: ${v2Colors.surface};
    overflow-y: auto;
    overscroll-behavior: contain;
  }

  .modal-footer {
    gap: 8px;
    padding: 14px 24px;
    border-top: 1px solid ${v2Colors.disabledSurface};
    background: #fff;
  }

  /* "Chiudi" — tonal red: recognisable as the close action without the
     solid red competing with the green "Seleziona" buttons */
  .modal-footer .btn-danger {
    padding-top: 9px;
    padding-bottom: 9px;
    border: 1px solid ${v2Colors.dangerBorder};
    border-radius: 10px;
    background: ${v2Colors.dangerSoft};
    color: ${v2Colors.danger};
    font-family: ${v2FontFamily};
    font-size: 13.5px;
    font-weight: 600;
    transition: background-color 150ms ease, border-color 150ms ease;

    &:hover,
    &:active {
      border-color: ${v2Colors.danger};
      background: ${v2Colors.dangerSoftHover};
      color: ${v2Colors.danger};
    }

    &:focus-visible {
      outline: 0;
      border-color: ${v2Colors.danger};
      box-shadow: 0 0 0 3px ${v2Colors.dangerSoftHover};
    }
  }

  @media screen and (max-width: ${v2Breakpoints.tablet}) {
    .modal-content {
      max-height: calc(100vh - 24px);
      max-height: calc(100dvh - 24px);
      border-radius: 16px;
    }

    .modal-header {
      padding: 14px 16px;
    }

    .modal-title {
      font-size: 16px;
    }

    /* 40px touch target */
    .modal-header .btn-close {
      width: 40px;
      height: 40px;
      margin-right: -8px;
    }

    .modal-body {
      padding: 14px 12px;
    }

    .modal-footer {
      padding: 12px 16px;
      padding-bottom: max(12px, env(safe-area-inset-bottom));
    }

    .modal-footer .btn-danger {
      min-height: 40px;
    }
  }

  /* Phones held sideways: give the body the height back */
  @media screen and (max-height: 500px) {
    .modal-dialog {
      margin-top: 8px;
      margin-bottom: 8px;
    }

    .modal-content {
      max-height: calc(100vh - 16px);
      max-height: calc(100dvh - 16px);
    }

    .modal-header {
      padding-top: 8px;
      padding-bottom: 8px;
    }

    .modal-footer {
      padding-top: 8px;
      padding-bottom: 8px;
    }
  }
`;

export default ResultModal;
